import warehouse from "../../../assets/images/home/warehouse.jpg";

const Warehouse = ({ data }) => (
  <div className="w-5/6 lg:w-4/5 mx-auto my-20">
    <h2 className="col-span-2 text-center text-3xl lg:text-4xl uppercase bg-blue-950 text-white py-4 lg:py-6">
      Our Warehouse
    </h2>

    <div className="grid md:grid-cols-2 lg:grid-cols-5 w-full">
      <div
        style={{ backgroundImage: `url(${warehouse})` }}
        className="lg:col-span-3 bg-cover bg-right-bottom xl:bg-center w-full h-40 md:h-full lg:h-96 xl:h-80"
      ></div>
      <p className="text-sm md:text-base text-white bg-blue-950 lg:col-span-2 p-3 xl:p-4 break-all">
        {data?.werehouse}
      </p>
    </div>
  </div>
);

export default Warehouse;
